/* eslint-disable linebreak-style */
import axios from 'axios';

export default axios.create({ baseURL: 'https://atomic-habits-api.onrender.com/api/user' });

